export default "__VITE_ASSET__a19b693b__"